import { useEffect, useState, useRef, RefObject } from 'react';
import { FaCaretRight } from 'react-icons/fa';
import Form from '../../Form';
import {
  InputData,
  initialInputData,
  inputDataConfig,
} from './inputData';
import {
  Wrapper,
  Title,
  ProgressWrapper,
  Progress,
  ProgressArrow,
  Desc,
  FormWrapper,
  Button
} from "./style"
import {API_URL} from '../../../const'

const Input = () => {
  const params = (new URL(window.location.href)).searchParams;
  const token = params.get("token")
  const emailEncoded: string|null = params.get("email")
  
  useEffect(() => {
    if (!token || !emailEncoded) {
      window.location.href = "/token-error"
      return
    }
    (async () => {
      console.log("api url:")
      console.log(API_URL + "ec/check-token?token=" + token)
      const res = await fetch(API_URL + "ec/check-token?token=" + token)
      if (res.status !== 200) {
        window.location.href = "/token-error"
        return
      }
      console.log("emailEncoded")
      console.log(emailEncoded)
      const email = atob(emailEncoded)
      console.log("email")
      console.log(email)
    })()
  }, [])

  return (
    <Wrapper>
      <Title>
        memart 本登録フォーム
      </Title>
      <ProgressWrapper>
        <Progress active>① 利用規約確認</Progress>
        <ProgressArrow><FaCaretRight/></ProgressArrow>
        <Progress>② 情報入力</Progress>
        <ProgressArrow><FaCaretRight/></ProgressArrow>
        <Progress>③ 完了</Progress>
      </ProgressWrapper>
      <Desc>
        下記の利用規約をご確認いただき、承諾いただける方は、ページ下部の「承諾」を押してください。
      </Desc>
      <Button onClick={async () => {
        window.location.href = '/ec-regist?email=' + emailEncoded
      }}>
        承諾
      </Button>
    </Wrapper>
  )
}
export default Input;
